import styled from 'styled-components'

export const QualityIconsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 100%;
  padding-bottom: 65px;
`

export const QualityIconItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  position: relative;
  cursor: pointer;
  padding: 10px;
  border-radius: 8px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`

export const QualityValue = styled.span`
  font-weight: 600;
  text-align: center;
  color: #333;
  transition: color 0.2s ease;

  ${QualityIconItem}:hover & {
    color: #a0522d;
  }
`

export const QualityIcon = styled.div`
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;

  img {
    max-width: 100%;
    max-height: 100%;
  }

  ${QualityIconItem}:hover & {
    transform: scale(1.1);
  }
`

export const QualityLabel = styled.span`
  font-size: 13px;
  color: #666;
  font-weight: 500;
  text-align: center;
`

export const ChartTooltip = styled.div`
  position: fixed;
  z-index: 9999;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 15px;
  width: 420px;
`

export const ChartTooltipTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
`
